import React from 'react';
import { MultiSelect, MultiSelectProps } from '@mantine/core';

interface Area {
  value: string;
  label: string;
}

interface MultiAreaSelectorProps extends Omit<MultiSelectProps, 'data' | 'value' | 'onChange'> {
  /* eslint-disable */
  areas: Area[];
  value: string[];
  onChange: (value: string[]) => void;
  loading?: boolean;
  /* eslint-enable */
}

const MultiAreaSelector: React.FC<MultiAreaSelectorProps> = ({
  areas,
  value,
  onChange,
  loading = false,
  ...props
}) => {
  return (
    <MultiSelect
      data={areas}
      value={value}
      onChange={onChange}
      searchable
      clearable
      placeholder='Select areas...'
      label='Areas'
      description='Select one or more areas for this admin user'
      disabled={loading}
      {...props}
    />
  );
};

export default MultiAreaSelector;
